import type { PostLikesData } from '@/types';
import { LikeButton } from '@/ui/LikeButton';
import { TooltipWrapper } from '@/ui/TooltipWrapper';

import * as styles from '../PostActions.css';

type LikeActionButtonProps = {
  data: PostLikesData;
  translations?: Record<string, string>;
};

export const LikeActionButton = ({ data, translations, ...props }: LikeActionButtonProps) => {
  const label = translations?.['search.pagination.like'];
  // likesCount of 0 renders no text (`likesCount || ''`). Include a visible count in the name
  // because aria-label replaces the button's text for the accessible name.
  const visibleCount = data?.likesCount ? String(data.likesCount) : '';
  const ariaLabel = label ? (visibleCount ? `${label} ${visibleCount}` : label) : undefined;

  if (label) {
    return (
      <TooltipWrapper portalId="post-actions-container" tooltipText={label}>
        <LikeButton data={data} styles={styles} buttonType="submit" {...props} aria-label={ariaLabel} />
      </TooltipWrapper>
    );
  }

  return <LikeButton data={data} styles={styles} buttonType="submit" onClick={undefined} />;
};
